export enum InferenceDevice {
  CPU = "CPU",
  GPU = "GPU",
}
